module.exports = __webpack_public_path__ + "static/media/card-bg.477d2801.png";